import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavMenuDirective } from '../../../directives/nav-menu/nav-menu.directive';
import { MegaMenuComponent } from './mega-menu.component';
import { SharedModule } from '../../../../shared/shared.module';
import { SharedPipesModule } from '../../../pipes/shared-pipes.module';

@NgModule({
    declarations: [
        MegaMenuComponent,
        NavMenuDirective
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        SharedPipesModule
    ],
    exports: [MegaMenuComponent]
})
export class MegaMenuNavModule { }
